"use strict";

exports.__esModule = true;
exports.TradingPairNotFound = exports.NotSupportEVMBalance = exports.NotSupportETHAddress = exports.CurrencyNotFound = void 0;
class NotSupportETHAddress extends Error {
  constructor(address) {
    super();
    this.message = `not support eth address ${address}`;
    this.name = 'NotSupportETHAddress';
  }
}
exports.NotSupportETHAddress = NotSupportETHAddress;
class NotSupportEVMBalance extends Error {
  constructor() {
    super();
    this.message = 'not support evm balance query, please init the sdk with wsProvider';
    this.name = 'NotSupportEVMBalance';
  }
}
exports.NotSupportEVMBalance = NotSupportEVMBalance;
class CurrencyNotFound extends Error {
  constructor(name) {
    super();
    this.message = `can't find ${name} currency in current network`;
    this.name = 'CurrencyNotFound';
  }
}
exports.CurrencyNotFound = CurrencyNotFound;
class TradingPairNotFound extends Error {
  constructor(name) {
    super();
    this.message = `can't find ${name} trading pair in current network`;
    this.name = 'TradingPairNotFound';
  }
}
exports.TradingPairNotFound = TradingPairNotFound;